import ErrorIcon from '@mui/icons-material/Warning';
import { Message } from '../../../type';
import { useUploadProgress } from '../../../hooks/store/useUploadProgress';
import { SxProps, Theme } from '@mui/material';

export const MediaUploadErrorIndicator = (props: {
  message: Message;
  sx?: SxProps<Theme>;
}) => {
  const {
    channelGuid,
    guid: messageGuid,
    messageType,
    localMessage,
  } = props.message;
  const uploadProgress = useUploadProgress(channelGuid, messageGuid);
  if (
    !localMessage ||
    !uploadProgress ||
    (messageType !== 'IMAGE' && messageType !== 'VIDEO')
  ) {
    return null;
  }
  const [state] = uploadProgress;
  if (state !== 'error') {
    return null;
  }
  return (
    <ErrorIcon sx={{ with: 20, height: 20, color: '#d00070', ...props.sx }} />
  );
};
